import { render, staticRenderFns } from "./messages-item.vue?vue&type=template&id=3998f508"
import script from "./messages-item.vue?vue&type=script&lang=js"
export * from "./messages-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports